<template>
  <div>
    <nav
      class="st-nav navbar main-nav navigation transparent dark-link"
      id="main-nav"
    >
      <div class="container mt-2 mb-2" style="padding-left: 0px">
        <ul class="st-nav-menu nav navbar-nav">
          <li class="st-nav-section st-nav-primary nav-item">
            <div class="text-center">
              <figure class="mockup mr-1">
                <img
                  style="height: 60px"
                  src="../../assets/logo4.svg"
                  alt="..."
                />
              </figure>
            </div>
            <div class="text-center ml-2">
              <figure class="mockup">
            
              </figure>
            </div>
          </li>

          <li
            class="st-nav-section st-nav-secondary nav-item"
          >
            <a class="b nav-link" href="tel:+74953804161">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.47548 2.00361L6.44703 2.00173C5.13019 1.94046 3.2719 3.52383 2.58526 4.66906C1.83186 5.69814 1.81737 7.06475 2.47529 8.6455L2.57901 8.8842C4.31265 13.1537 10.818 19.6509 15.0709 21.4297C16.6981 22.191 18.1483 22.2049 19.291 21.3821C20.2956 20.8078 21.9431 18.8968 21.8955 17.5396C21.8503 16.9812 21.5907 16.5254 21.1875 16.1104L21.0891 16.0127L20.8152 15.7594C19.8234 14.8725 18.1062 13.6098 17.5751 13.4982C16.9515 13.3682 16.5286 13.4846 15.8616 13.8523L15.6132 13.9936C15.1389 14.2671 14.9693 14.3139 14.7446 14.2319C12.3717 13.2578 10.6985 11.5761 9.71791 9.16394C9.65417 8.98522 9.68569 8.82913 9.89193 8.4507L10.0006 8.25773C10.4502 7.47256 10.6009 7.02869 10.4593 6.34521L10.4343 6.25664C10.202 5.58042 8.77842 3.67254 7.98799 2.84195L7.86065 2.71312C7.44871 2.30856 6.99574 2.0484 6.47548 2.00361ZM6.36497 3.46397L6.4192 3.47438C6.5141 3.50117 6.62602 3.56689 6.75204 3.67518L6.84383 3.75911L7.01708 3.9415C7.68914 4.68353 8.99113 6.43341 9.03419 6.64265C9.07489 6.83908 9.02988 7.00325 8.81663 7.39014L8.70506 7.58738C8.23546 8.40967 8.0901 8.93988 8.35996 9.68968C9.4991 12.4936 11.4597 14.464 14.2214 15.5971C14.9336 15.8575 15.4386 15.7534 16.1539 15.3657L16.399 15.2273C16.8844 14.9466 17.0621 14.8857 17.2784 14.9308C17.4898 14.9752 19.3814 16.3949 20.0749 17.0621L20.1559 17.1426C20.3347 17.3268 20.4325 17.4985 20.443 17.6259C20.4526 17.9236 20.1545 18.483 19.6281 19.0935C19.2534 19.5281 18.7668 19.9725 18.5559 20.1198L18.5055 20.1524C17.8239 20.6389 16.9821 20.6598 15.8691 20.1855L15.6572 20.0908C11.8121 18.4818 5.76508 12.488 4.01861 8.54808L3.91511 8.30456C3.37395 7.10758 3.32905 6.2325 3.71762 5.5958L3.79554 5.47919C4.24591 4.73347 5.60316 3.55891 6.27894 3.4685L6.36497 3.46397ZM14.4217 2.24373L14.5206 2.24805C18.4503 2.68669 21.5537 5.803 21.9954 9.75343C22.0403 10.155 21.7529 10.5171 21.3535 10.5622C20.9541 10.6074 20.5939 10.3184 20.549 9.91687C20.1833 6.64586 17.6138 4.06559 14.36 3.70241C13.9605 3.65782 13.6726 3.29611 13.717 2.8945C13.7539 2.55982 14.0099 2.30305 14.3254 2.25256L14.4217 2.24373ZM14.4813 5.70096L14.5795 5.7134C16.5878 6.10696 18.1572 7.6848 18.5487 9.70396C18.6256 10.1006 18.3681 10.4848 17.9736 10.5621C17.5791 10.6394 17.197 10.3805 17.1201 9.98391C16.8421 8.54969 15.7276 7.42921 14.301 7.14966C13.9065 7.07236 13.6491 6.68817 13.726 6.29155C13.7901 5.96104 14.0661 5.7262 14.3846 5.70184L14.4813 5.70096Z"
                  fill="#333"
                />
              </svg>
              +7 495 380-41-61
            </a>
            <a class="b nav-link" @click="page('login')">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.3344 2.00024H7.66537C4.26779 2.00024 2.00037 4.43284 2.00037 7.91624V16.0842C2.00037 19.5709 4.26174 22.0002 7.66537 22.0002H16.3334C19.738 22.0002 22.0004 19.5709 22.0004 16.0842V7.91624C22.0004 4.42975 19.7381 2.00024 16.3344 2.00024ZM7.66537 3.50024H16.3344C18.8849 3.50024 20.5004 5.23521 20.5004 7.91624V16.0842C20.5004 18.7654 18.8847 20.5002 16.3334 20.5002H7.66537C5.11513 20.5002 3.50037 18.7656 3.50037 16.0842V7.91624C3.50037 5.23862 5.12071 3.50024 7.66537 3.50024ZM8.84027 9.39824C7.40412 9.39824 6.23927 10.564 6.23927 12.0002C6.23927 13.4365 7.40412 14.6022 8.84027 14.6022C10.0164 14.6022 11.0104 13.8214 11.3325 12.7502L13.4316 12.7501V13.8517L13.4384 13.9535C13.4881 14.3196 13.8019 14.6017 14.1816 14.6017C14.5958 14.6017 14.9316 14.266 14.9316 13.8517V12.7501L16.26 12.75L16.2603 13.8522L16.2671 13.954C16.3168 14.3201 16.6306 14.6022 17.0103 14.6022C17.4245 14.6022 17.7603 14.2665 17.7603 13.8522V12.0002L17.7534 11.8985C17.7038 11.5324 17.39 11.2502 17.0103 11.2502H14.2092C14.2 11.2499 14.1908 11.2497 14.1816 11.2497C14.1723 11.2497 14.1631 11.2499 14.1539 11.2502H11.3325C11.0104 10.1791 10.0164 9.39824 8.84027 9.39824ZM8.84027 10.8982C9.44864 10.8982 9.94227 11.392 9.94227 12.0002C9.94227 12.6084 9.44864 13.1022 8.84027 13.1022C8.2328 13.1022 7.73927 12.6083 7.73927 12.0002C7.73927 11.3921 8.2328 10.8982 8.84027 10.8982Z"
                  fill="#333"
                />
              </svg>

              Личный кабинет
            </a>
            <!-- <button type="button" class="btn btn-md  btn-primary btn-outlined" @click='page("login")'><i class="fas fa-sign-in-alt d-none d-md-inline mr-md-0 mr-lg-2"></i>Личный  кабинет</button> -->
          </li>

          <!-- <li class="st-nav-section st-nav-secondary nav-item"><a class="btn mr-3 px-3" href="login.html" target="_blank"><i class="fas fa-sign-in-alt d-none d-md-inline mr-md-0 mr-lg-2"></i> <span class="d-md-none d-lg-inline">Личный кабинет</span> </a> -->
          <!-- <a class="btn btn-rounded btn-solid px-3" href="signup.html" target="_blank"><i class="fas fa-user-plus d-none d-md-inline mr-md-0 mr-lg-2"></i> <span class="d-md-none d-lg-inline">Signup</span></a></li>Mobile Navigation -->
          <li class="st-nav-section st-nav-mobile nav-item">
            <button class="st-root-link navbar-toggler" type="button">
              <span class="icon-bar"></span> <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <div class="st-popup">
              <div class="st-popup-container">
                <a class="st-popup-close-button">Close</a>
                <div class="st-dropdown-content-group">
                  <h4 class="text-uppercase regular">Pages</h4>
                  <a class="regular text-primary" href="about.html"
                    ><i class="far fa-building mr-2"></i> About </a
                  ><a class="regular text-success" href="contact.html"
                    ><i class="far fa-envelope mr-2"></i> Contact </a
                  ><a class="regular text-warning" href="pricing.html"
                    ><i class="fas fa-hand-holding-usd mr-2"></i> Pricing </a
                  ><a class="regular text-primary" href="faqs.html"
                    ><i class="far fa-question-circle mr-2"></i> FAQs</a
                  >
                </div>
                <div class="st-dropdown-content-group border-top bw-2">
                  <h4 class="text-uppercase regular">Components</h4>
                  <div class="row">
                    <div class="col mr-4">
                      <a target="_blank" href="components/alert.html">Alerts</a>
                      <a target="_blank" href="components/badge.html">Badges</a>
                      <a target="_blank" href="components/button.html"
                        >Buttons</a
                      >
                      <a target="_blank" href="components/color.html">Colors</a>
                      <a target="_blank" href="components/accordion.html"
                        >Accordion</a
                      >
                      <a target="_blank" href="components/cookie-law.html"
                        >Cookielaw</a
                      >
                    </div>
                    <div class="col mr-4">
                      <a target="_blank" href="components/overlay.html"
                        >Overlay</a
                      >
                      <a target="_blank" href="components/progress.html"
                        >Progress</a
                      >
                      <a target="_blank" href="components/lightbox.html"
                        >Lightbox</a
                      >
                      <a target="_blank" href="components/tab.html">Tabs</a>
                      <a target="_blank" href="components/tables.html"
                        >Tables</a
                      >
                      <a target="_blank" href="components/typography.html"
                        >Typography</a
                      >
                    </div>
                  </div>
                </div>
                <div class="st-dropdown-content-group bg-light b-t">
                  <a href="login.html"
                    >Sign in <i class="fas fa-arrow-right"></i
                  ></a>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <li class="cherdack" style=" border-top:1px solid #eee; width: 100%;  ">
        <div
          class="container st-nav-section st-nav-primary nav-item pa-0"
          style="justify-content: left"
        >
          <a
            class="item-products st-has-dropdown nav-link"
            style=" border-top:3px solid #16336E; "
            data-dropdown="blocks"
            href="https://palata-nk.ru/nalogoplatelshchiku/"
            >Основной сайт
          </a>
          <span class="nav-link active" style="cursor:auto !important; border-top:3px solid ; color:#04A27C !important;"
            >Обучение и повышение квалификации
          </span>
          <a
            class="item-products st-has-dropdown nav-link"
            style="border-top:3px solid #ffa500; "
            data-dropdown="blocks"
            href="https://palata-nk.ru/nalogoplatelshchiku/"
            >Налогоплательщику
          </a>
         
          <a
            class="item-company st-has-dropdown nav-link"
            style=" border-top:3px solid #e41819; "
            target="_blank"
            href="/library/"
            >Налоговая библиотека
          </a>
        </div>
      </li>
      
      
      <!-- <div class="st-dropdown-root">
        <div class="st-dropdown-bg">
          <div class="st-alt-bg"></div>
        </div>
        <div class="st-dropdown-arrow"></div>
        <div class="st-dropdown-container">
          <div class="st-dropdown-section" data-dropdown="blocks">
            <div class="st-dropdown-content">
              <div class="st-dropdown-content-group">
                <div class="row">
                  <div class="col mr-4">
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="blocks/call-to-action.html"
                      >Call to actions</a
                    >
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="blocks/contact.html"
                      >Contact</a
                    >
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="blocks/counter.html"
                      >Counters</a
                    >
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="blocks/faqs.html"
                      >FAQs</a
                    >
                  </div>
                  <div class="col mr-4">
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="blocks/footer.html"
                      >Footers</a
                    >
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="blocks/form.html"
                      >Forms</a
                    >
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="blocks/navbar.html"
                      >Navbar</a
                    >
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="blocks/navigation.html"
                      >Navigation</a
                    >
                  </div>
                  <div class="col">
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="blocks/pricing.html"
                      >Pricing</a
                    >
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="blocks/slider.html"
                      >Sliders</a
                    >
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="blocks/team.html"
                      >Team</a
                    >
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="blocks/testimonial.html"
                      >Testimonials</a
                    >
                  </div>
                </div>
              </div>
              <div class="st-dropdown-content-group">
                <h3 class="link-title">
                  <i class="fas fa-long-arrow-alt-right icon"></i> Coming soon
                </h3>
                <div class="ml-5">
                  <span class="dropdown-item text-secondary">Dividers </span
                  ><span class="dropdown-item text-secondary">Gallery </span
                  ><span class="dropdown-item text-secondary">Screenshots</span>
                </div>
              </div>
            </div>
          </div>
          <div class="st-dropdown-section" data-dropdown="pages">
            <div class="st-dropdown-content">
              <div class="st-dropdown-content-group">
                <div class="mb-4">
                  <h3 class="text-darker light text-nowrap">
                    <span class="bold regular">Useful pages</span> you'll need
                  </h3>
                  <p class="text-secondary mt-0">Get a complete design stack</p>
                </div>
                <div class="row">
                  <div class="col">
                    <ul class="mr-4">
                      <li>
                        <h4 class="text-uppercase regular">Error</h4>
                      </li>
                      <li><a target="_blank" href="403.html">403 Error</a></li>
                      <li><a target="_blank" href="404.html">404 Error</a></li>
                      <li><a target="_blank" href="405.html">405 Error</a></li>
                    </ul>
                  </div>
                  <div class="col">
                    <ul class="mr-4">
                      <li>
                        <h4 class="text-uppercase regular">User</h4>
                      </li>
                      <li><a target="_blank" href="login.html">Login</a></li>
                      <li>
                        <a target="_blank" href="register.html">Register</a>
                      </li>
                      <li><a target="_blank" href="forgot.html">Forgot</a></li>
                    </ul>
                  </div>
                  <div class="col">
                    <ul>
                      <li>
                        <h4 class="text-uppercase regular">Extra</h4>
                      </li>
                      <li>
                        <a target="_blank" href="pricing.html">Pricing</a>
                      </li>
                      <li><a target="_blank" href="terms.html">Terms</a></li>
                      <li><a target="_blank" href="faqs.html">FAQ</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="st-dropdown-content-group">
                <a class="dropdown-item bold" href="about.html"
                  ><i class="far fa-building icon"></i> About </a
                ><a class="dropdown-item bold" href="contact.html"
                  ><i class="far fa-envelope icon"></i> Contact </a
                ><a class="dropdown-item bold" href="pricing.html"
                  ><i class="fas fa-hand-holding-usd icon"></i> Pricing</a
                >
              </div>
            </div>
          </div>
          <div class="st-dropdown-section" data-dropdown="components">
            <div class="st-dropdown-content">
              <div class="st-dropdown-content-group">
                <a
                  class="dropdown-item"
                  target="_blank"
                  href="components/color.html"
                >
                  <div class="media mb-4">
                    <i
                      class="fas fa-palette mr-2 bg-primary rounded-circle icon-md text-contrast center-flex"
                    ></i>
                    <div class="media-body">
                      <h3 class="link-title m-0">Colors</h3>
                      <p class="m-0 text-secondary">
                        Get to know DashCore color options
                      </p>
                    </div>
                  </div> </a
                ><a
                  class="dropdown-item"
                  target="_blank"
                  href="components/accordion.html"
                >
                  <div class="media mb-4">
                    <i
                      class="fas fa-bars mr-2 bg-primary rounded-circle icon-md text-contrast center-flex"
                    ></i>
                    <div class="media-body">
                      <h3 class="link-title m-0">Accordion</h3>
                      <p class="m-0 text-secondary">
                        Useful accordion elements
                      </p>
                    </div>
                  </div> </a
                ><a
                  class="dropdown-item"
                  target="_blank"
                  href="components/cookie-law.html"
                >
                  <div class="media mb-4">
                    <i
                      class="fas fa-cookie-bite mr-2 bg-primary rounded-circle icon-md text-contrast center-flex"
                    ></i>
                    <div class="media-body">
                      <h3 class="link-title m-0">CookieLaw</h3>
                      <p class="m-0 text-secondary">
                        Comply with the hideous EU Cookie Law
                      </p>
                    </div>
                  </div>
                </a>
                <h4 class="text-uppercase regular">Huge components list</h4>
                <div class="row">
                  <div class="col mr-4">
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="components/alert.html"
                      >Alerts</a
                    >
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="components/badge.html"
                      >Badges</a
                    >
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="components/button.html"
                      >Buttons</a
                    >
                  </div>
                  <div class="col mr-4">
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="components/overlay.html"
                      >Overlay</a
                    >
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="components/progress.html"
                      >Progress</a
                    >
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="components/lightbox.html"
                      >Lightbox</a
                    >
                  </div>
                  <div class="col mr-4">
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="components/tab.html"
                      >Tabs</a
                    >
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="components/tables.html"
                      >Tables</a
                    >
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="components/typography.html"
                      >Typography</a
                    >
                  </div>
                </div>
              </div>
              <div class="st-dropdown-content-group">
                <a
                  class="dropdown-item"
                  target="_blank"
                  href="components/wizard.html"
                  >Wizard
                  <span class="badge badge-pill badge-primary">New</span></a
                >
                <span class="dropdown-item d-flex align-items-center text-muted"
                  >Timeline <i class="fas fa-ban ml-auto"></i
                ></span>
                <span class="dropdown-item d-flex align-items-center text-muted"
                  >Process <i class="fas fa-ban ml-auto"></i
                ></span>
              </div>
            </div>
          </div>
          <div class="st-dropdown-section" data-dropdown="blog">
            <div class="st-dropdown-content">
              <div class="st-dropdown-content-group">
                <div class="row">
                  <div class="col mr-4">
                    <h4 class="regular text-uppercase">Full width</h4>
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="blog/blog-post.html"
                      >Single post</a
                    >
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="blog/blog-grid.html"
                      >Posts Grid</a
                    >
                  </div>
                  <div class="col mr-4">
                    <h4 class="regular text-uppercase">Sidebar left</h4>
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="blog/blog-post-sidebar-left.html"
                      >Single post</a
                    >
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="blog/blog-grid-sidebar-left.html"
                      >Posts Grid</a
                    >
                  </div>
                  <div class="col mr-4">
                    <h4 class="regular text-uppercase">Sidebar right</h4>
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="blog/blog-post-sidebar-right.html"
                      >Single post</a
                    >
                    <a
                      class="dropdown-item"
                      target="_blank"
                      href="blog/blog-grid-sidebar-right.html"
                      >Posts Grid</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="st-dropdown-section" data-dropdown="shop">
            <div class="st-dropdown-content">
              <div class="st-dropdown-content-group">
                <a class="dropdown-item" target="_blank" href="shop/home.html">
                  <div class="media align-items-center">
                    <div
                      class="bg-success text-contrast icon-md center-flex rounded-circle mr-3"
                    >
                      <i class="fas fa-shopping-basket"></i>
                    </div>
                    <div class="media-body">
                      <h3 class="link-title m-0">Home</h3>
                     <p class="m-0 text-secondary">
                        Online store home with an outstanding UX
                      </p>
                    </div>
                  </div> </a
                ><a class="dropdown-item" target="_blank" href="shop/cart.html">
                  <div class="media align-items-center">
                    <div
                      class="bg-info text-contrast icon-md center-flex rounded-circle mr-3"
                    >
                      <i class="fas fa-shopping-cart"></i>
                    </div>
                    <div class="media-body">
                      <h3 class="link-title m-0">Cart</h3>
                      <p class="m-0 text-secondary">
                        Online store shopping cart
                      </p>
                    </div>
                  </div>
                </a>
              </div>
              <div class="st-dropdown-content-group">
                <h3 class="link-title">
                  <i class="fas fa-money-check-alt icon"></i> Checkout
                </h3>
                <div class="ml-5">
                  <a
                    class="dropdown-item text-secondary"
                    target="_blank"
                    href="shop/checkout-customer.html"
                    >Customer <i class="fas fa-angle-right ml-2"></i> </a
                  ><a
                    class="dropdown-item text-secondary"
                    target="_blank"
                    href="shop/checkout-shipping.html"
                    >Shipping Information
                    <i class="fas fa-angle-right ml-2"></i> </a
                  ><a
                    class="dropdown-item text-secondary"
                    target="_blank"
                    href="shop/checkout-payment.html"
                    >Payment Methods <i class="fas fa-angle-right ml-2"></i> </a
                  ><a
                    class="dropdown-item text-secondary"
                    target="_blank"
                    href="shop/checkout-confirmation.html"
                    >Order Review <i class="fas fa-angle-right ml-2"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </nav>
    <main class="" >
        
      <!-- Payment Services Heading -->
      <header class="  payment-services-header bg-image-0" id="home"  style="background-color:#04A27C">
        

        <div class="container pt-5" >
          <div class=" row align-items-center">
            <div class="col-md-12 text-center text-md-left">
              <!-- <span class="py-2">Образование через всю жизнь</span> -->
              <h2 class="bold font-md display-lg-4 b-white">
                Официальные спикеры и лекторы </span>
              </h2>
            </div>
            <!--  <div class="col-md-6">
              <div class="shapes-container">
                <div class="static-shape>"></div>
              </div>
             <figure class="figure-box mockup cutout x2 bottom-right">
                <div class="screens">
                  <img src="img/payment-services/bg.png" alt="..." />
                  <img
                    src="/testimodals/kruchkov.jpg"
                    class="position-absolute"
                    alt="..."
                  />
                </div>
                <div
                  class="promo-box card shadow-lg border-0"
                  data-aos="fade-up"
                  data-aos-delay="0"
                  data-aos-duration="1000"
                >
                  <div class="card-body p-5 text-center">
                    <figure class="icon-xxl mx-auto">
                      <img src="logo2.svg" alt="..." />
                    </figure>
                    <h6 class="h6 mb-0">
                      Находка для меня – <br />наличие блока по <br />
                      финансовому анализу
                    </h6>
                    <hr class="my-3 mx-auto w-25" />
                    <p class="mt-4 small text-muted mb-0">
                      Егор Крючков, <br />заместитель директора <br />
                      юридического департамента <br />
                      по налоговым вопросам <br />
                      АКГ «Созидание и Развитие»
                    </p>
                  </div>
                </div>
              </figure> 
            </div> -->
          </div>
        </div>

        <div
          class="d-flex justify-center"
          :color="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'"
          flat
          style=";"
        >
        <div
            class=" b dropdown"
            href="#"
            >
              <v-list-item three-line class="dropbtn">
                <v-list-item-avatar
                  tile
                  size="80"
                > <v-img contain src='future2.svg'></v-img></v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="b"  v-scroll-to="'#future-nalog'">
                    Будущему <br>налоговому консультанту
                  </v-list-item-title>
                   <v-list-item-subtitle>
                     <a class='b' @click="page('login')">
                        <svg class='icon-mb' width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.0019 7.4795V5.77979C13.0019 3.79033 11.3885 2.17692 9.39904 2.17692C7.40959 2.16821 5.78984 3.77371 5.78113 5.76396V5.77979V7.4795" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4159 16.8226H6.36675C4.709 16.8226 3.36475 15.4792 3.36475 13.8206V10.4252C3.36475 8.76661 4.709 7.42316 6.36675 7.42316H12.4159C14.0736 7.42316 15.4179 8.76661 15.4179 10.4252V13.8206C15.4179 15.4792 14.0736 16.8226 12.4159 16.8226Z" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M9.39144 11.2438V13.0021" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        Личный кабинет
                      </a>
                  </v-list-item-subtitle>
                </v-list-item-content>

              </v-list-item>
            <!-- <button >Будущему налоговому консультанту</button> -->
            <div class="dropdown-content">
              <a @click="page('/request/')" >
                <svg width="18" class='icon-mb'  height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.7871 12.1676H6.37207" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11.7871 9.02771H6.37207" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.43856 5.89508H6.37231" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9315 2.06238C11.9315 2.06238 6.17374 2.06538 6.16474 2.06538C4.09474 2.07813 2.81299 3.44013 2.81299 5.51763V12.4146C2.81299 14.5026 4.10449 15.8699 6.19249 15.8699C6.19249 15.8699 11.9495 15.8676 11.9592 15.8676C14.0292 15.8549 15.3117 14.4921 15.3117 12.4146V5.51763C15.3117 3.42963 14.0195 2.06238 11.9315 2.06238Z" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

                Подать заявление на обучение
                </a>
              <a href="/library/">
                <svg width="18" class='icon-mb'  height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99988 2.06268C12.8316 2.06268 15.9374 5.16918 15.9374 9.00018C15.9374 12.8312 12.8316 15.9377 8.99988 15.9377C5.16888 15.9377 2.06238 12.8312 2.06238 9.00018C2.06238 5.16918 5.16888 2.06268 8.99988 2.06268Z" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.99622 6.15326V9.46751" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.99625 11.8471H9.00375" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Вопросы и ответы о профессии
              </a>
            </div>
          </div>
     
        <div
            class="b dropdown"
            >
           
              <v-list-item three-line class="dropbtn">
                 <v-list-item-avatar
                  tile
                  
                  size="80"
                  
                >  <v-img contain src='attest2.svg'></v-img></v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="b">
                    Аттестованному <br>налоговому консультанту
                  </v-list-item-title>
                  <v-list-item-subtitle>
                     <a class='b' @click="page('login')">
                        <svg class='icon-mb' width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.0019 7.4795V5.77979C13.0019 3.79033 11.3885 2.17692 9.39904 2.17692C7.40959 2.16821 5.78984 3.77371 5.78113 5.76396V5.77979V7.4795" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4159 16.8226H6.36675C4.709 16.8226 3.36475 15.4792 3.36475 13.8206V10.4252C3.36475 8.76661 4.709 7.42316 6.36675 7.42316H12.4159C14.0736 7.42316 15.4179 8.76661 15.4179 10.4252V13.8206C15.4179 15.4792 14.0736 16.8226 12.4159 16.8226Z" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M9.39144 11.2438V13.0021" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        Личный кабинет
                      </a>
                  </v-list-item-subtitle>
                </v-list-item-content>

               
              </v-list-item>

            <div class="dropdown-content">
              <a href="#"  v-scroll-to="'#future-nalog'">
                  <svg width="18"class='icon-mb'   height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2141 1.5H14.6641C15.6777 1.5 16.5 2.32942 16.5 3.35264V5.82308C16.5 6.84552 15.6777 7.67571 14.6641 7.67571H12.2141C11.1997 7.67571 10.3774 6.84552 10.3774 5.82308V3.35264C10.3774 2.32942 11.1997 1.5 12.2141 1.5Z" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.33669 1.5H5.78587C6.80027 1.5 7.62256 2.32942 7.62256 3.35264V5.82308C7.62256 6.84552 6.80027 7.67571 5.78587 7.67571H3.33669C2.32228 7.67571 1.5 6.84552 1.5 5.82308V3.35264C1.5 2.32942 2.32228 1.5 3.33669 1.5Z" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.33669 10.3243H5.78587C6.80027 10.3243 7.62256 11.1537 7.62256 12.1777V14.6474C7.62256 15.6706 6.80027 16.5 5.78587 16.5H3.33669C2.32228 16.5 1.5 15.6706 1.5 14.6474V12.1777C1.5 11.1537 2.32228 10.3243 3.33669 10.3243Z" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2141 10.3243H14.6641C15.6777 10.3243 16.5 11.1537 16.5 12.1777V14.6474C16.5 15.6706 15.6777 16.5 14.6641 16.5H12.2141C11.1997 16.5 10.3774 15.6706 10.3774 14.6474V12.1777C10.3774 11.1537 11.1997 10.3243 12.2141 10.3243Z" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                  Программая лояльности
                </a>
              <a href="">
                <svg width="18" class='icon-mb'  height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.43359 11.0861L7.67844 8.16853L10.2391 10.18L12.4359 7.34473" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <ellipse cx="14.9966" cy="3.1502" rx="1.44165" ry="1.44165" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11.1933 2.34015H5.74253C3.48395 2.34015 2.0835 3.93969 2.0835 6.19827V12.2601C2.0835 14.5186 3.45649 16.1113 5.74253 16.1113H12.1956C14.4542 16.1113 15.8547 14.5186 15.8547 12.2601V6.98088" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Повышение квалификации
              </a>
              <a href="#">
                <svg width="18" class='icon-mb'  height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.31958 7.05322H15.6875" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.3315 9.9823H12.3384" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.00335 9.9823H9.0103" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.66839 9.9823H5.67534" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.3315 12.8972H12.3384" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.00335 12.8972H9.0103" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.66839 12.8972H5.67534" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.0327 1.5V3.96809" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.97411 1.5V3.96809" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.1787 2.68439H5.82822C3.6257 2.68439 2.25 3.91134 2.25 6.16666V12.9539C2.25 15.2447 3.6257 16.5 5.82822 16.5H12.1718C14.3812 16.5 15.75 15.2659 15.75 13.0106V6.16666C15.7569 3.91134 14.3882 2.68439 12.1787 2.68439Z" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

                Мероприятия
              </a>
              <a href="/library/">
                <svg width="18" class='icon-mb'  height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99988 2.06268C12.8316 2.06268 15.9374 5.16918 15.9374 9.00018C15.9374 12.8312 12.8316 15.9377 8.99988 15.9377C5.16888 15.9377 2.06238 12.8312 2.06238 9.00018C2.06238 5.16918 5.16888 2.06268 8.99988 2.06268Z" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.99622 6.15326V9.46751" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.99625 11.8471H9.00375" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

                Вопросы и ответы
                </a>
            </div>
          </div>

        <div
            class=" b dropdown"
            href="#"
            >
              <v-list-item two-line class="dropbtn">
                <v-list-item-avatar
                  tile
                  size="80"
                ><v-img contain src='people.svg' ></v-img></v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="b">
                    Образовательным организациям <br> и преподавателям
                  </v-list-item-title>
                  <v-list-item-subtitle>
                     <a class='b' @click="page('login')">
                        <svg class='icon-mb' width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.0019 7.4795V5.77979C13.0019 3.79033 11.3885 2.17692 9.39904 2.17692C7.40959 2.16821 5.78984 3.77371 5.78113 5.76396V5.77979V7.4795" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4159 16.8226H6.36675C4.709 16.8226 3.36475 15.4792 3.36475 13.8206V10.4252C3.36475 8.76661 4.709 7.42316 6.36675 7.42316H12.4159C14.0736 7.42316 15.4179 8.76661 15.4179 10.4252V13.8206C15.4179 15.4792 14.0736 16.8226 12.4159 16.8226Z" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M9.39144 11.2438V13.0021" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        Личный кабинет
                      </a>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            <div class="dropdown-content">
              <a @click="page('/request-org/')" v-scroll-to="'#org-nalog'">
                <svg width="18" class='icon-mb'  height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.2749 14.9236H15.0577" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.64128 3.71677C10.194 3.01252 11.0873 3.04927 11.7923 3.60202L12.8348 4.41952C13.5398 4.97227 13.7895 5.82952 13.2368 6.53527L7.02003 14.4665C6.81228 14.732 6.49503 14.8888 6.15753 14.8925L3.75978 14.9233L3.21678 12.587C3.14028 12.2593 3.21678 11.9143 3.42453 11.648L9.64128 3.71677Z" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M8.47705 5.20209L12.0726 8.02059" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>

                Заполнить заявку на аккредитацию
                </a>
              <a href="#">
               <svg width="18" class='icon-mb'  height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99988 2.06268C12.8316 2.06268 15.9374 5.16918 15.9374 9.00018C15.9374 12.8312 12.8316 15.9377 8.99988 15.9377C5.16888 15.9377 2.06238 12.8312 2.06238 9.00018C2.06238 5.16918 5.16888 2.06268 8.99988 2.06268Z" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.99622 6.15326V9.46751" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.99625 11.8471H9.00375" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>


                Вопросы и ответы
                </a>
            </div>
          </div>
      </div>
      </header>
      <!-- Credit Cards Management -->

      


      <section
        class="section with-promo "
        id="org-nalog"
        data-aos="fade-up"
        data-aos-delay="0"
        data-aos-offset="100"
        style="margin-top:80px !important"
      >
        <div class="container ">
          <div class="row gap-y align-items-center">
            <div class="col-md-12">
            
             
            <section class="hero-section">
              <div class="card-grid">
                <a class="card-spicker" v-for='lec in lectors'>
                  <div class="card__background" :style="lector_background(lec.photo)"></div>
                  <div class="card__content">
                    <!-- <p class="card__category">Category</p> -->
                    <h3 class="card__heading">{{lec.name}} </h3>
                  </div>
                </a>
                <a class="card-spicker" >
                  <div class="card__background" style="background-image: url(https://palata-nk.ru/upload/iblock/c91/c91d497011a14620178d597f58ec6f78.jpg)"></div>
                  <div class="card__content">
                    <!-- <p class="card__category">Category</p> -->
                    <h3 class="card__heading">Костанец Богдан Иванович</h3>
                  </div>
                </a>
                <a class="card-spicker" >
                  <div class="card__background" style="background-image: url(https://palata-nk.ru/upload/iblock/e13/e13bc30507f9bf601add55f2bbee3fda.jpg)"></div>
                  <div class="card__content">
                    <!-- <p class="card__category">Category</p> -->
                    <h3 class="card__heading">Коноплева Ирина Сергеевна</h3>
                  </div>
                </a>
                <a class="card-spicker" >
                  <div class="card__background" style="background-image: url(https://palata-nk.ru/upload/iblock/858/8589c75b690a3d12abf892de6da952fc.jpg)"></div>
                  <div class="card__content">
                    <!-- <p class="card__category">повышение квалификации</p> -->
                    <h3 class="card__heading">Кузнецова Юлия Адамовна</h3>
                  </div>
                </a>
              </div>
            </section>
          
            </div>
          </div>
        </div>
      </section>


      <footer class="site-footer section mt-10">
        <div class="container pb-4">
          <div class="row gap-y text-center text-md-left">
            <div class="col-md-4 mr-auto">
              <img src="../../assets/logo3.svg" alt="" class="logo" />
              <p class="mt-2 mb-md-0 b  text-md-left">
                © 2002-2021 Все права защищены. <br>
                <small>При воспроизведении материалов на других сайтах обязательна
                гиперссылка на palata-nk.ru</small>
              </p>
            </div>
            <div class="col-md-2">
              <h6 class="bold b text-dark">Контакты</h6>
              <nav class="nav flex-column">
                <a class="nav-item b" href="about.html">+7 495 380-41-61 </a>
                <a class="nav-item b" href="about.html">+7 903 130-05-74</a>
              </nav>
               <nav class="nav mt-2">
                <a
                  href="https://www.facebook.com/palatanalog"
                  class="btn btn-circle btn-sm btn-primary mr-1"
                  ><i class="fab fa-facebook"></i
                ></a>
                <a
                  href="https://www.youtube.com/channel/UC9L8GL4f9y1r4I8mD9sO8TQ"
                  class="btn btn-circle btn-sm btn-primary mr-1"
                  ><i class="fab fa-youtube"></i
                ></a>
                <a href="https://www.instagram.com/palata_nk/" class="btn btn-circle btn-sm btn-primary"
                  ><i class="fab fa-instagram"></i
                ></a>
              </nav>
            </div>
            <div class="col-md-2">
              <nav class="nav flex-column">
                <h6 class="bold b text-dark">Офис палаты</h6>
                <a class="nav-item b" href="#"
                  >г. Москва, метро Курская, Красные ворота, улица Земляной Вал,
                  дом 4, строение 1</a
                >
              </nav>
            </div>
            <div class="col-md-2">
              <nav class="nav flex-column">
                <h6 class="bold b text-dark">Палата налоговых консультантов</h6>
                <a class="nav-item b" href="#">О Палате</a>
                <a class="nav-item b" href="#">Налоговое бюро</a>
                <a class="nav-item b" href="#">Членство</a>
                <!-- <a class="nav-item b " href="#">Реестры</a>
                        <a class="nav-item b " href="#">Международная деятельность</a>
                        <a class="nav-item b " href="#">Проекты</a>
                        <a class="nav-item b " href="#">Коворкинг</a>
                        <a class="nav-item b " href="#">Мероприятия</a> -->
              </nav>
            </div>
          </div>
          <hr class="mt-5" />
          <cookie-consent>
            <template
              slot="message"
            >
            <div class='mr-6 mb-2'>
               Сайт использует файлы «cookie», с целью персонализации сервисов
                и повышения удобства пользования веб-сайтом. «Cookie»
                представляют собой небольшие файлы, содержащие информацию о
                предыдущих посещениях веб-сайта. Если вы не хотите использовать
                файлы «cookie», измените настройки браузера.
            </div>
            
            </template>

            <template
              slot="button"
            >
              <button class="btn btn-primary">Подтвердить</button>
            </template>
          </cookie-consent>
        </div>
      </footer>
    </main>
    <!-- themeforest:js -->
  </div>
</template>

<style  scoped>
.hero-section{
  align-items: flex-start;
  background-image: linear-gradient(15deg, #0f4667 0%, #2a6973 150%);
  display: flex;
  min-height: 100%;
  justify-content: center;
  padding: var(--spacing-xxl) var(--spacing-l);
}

.card-grid{
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-column-gap: var(--spacing-l);
  grid-row-gap: var(--spacing-l);
  max-width: var(--width-container);
  width: 100%;
}

@media(min-width: 540px){
  .card-grid{
    grid-template-columns: repeat(2, 1fr); 
  }
}

@media(min-width: 960px){
  .card-grid{
    grid-template-columns: repeat(4, 1fr); 
  }
}

.card-spicker{
  list-style: none;
  position: relative;
}

.card-spicker:before{
  content: '';
  display: block;
  padding-bottom: 150%;
  width: 100%;
}

.card__background{
  background-size: cover;
  background-position: center;
  border-radius: var(--spacing-l);
  bottom: 0;
  filter: brightness(0.75) saturate(1.2) contrast(0.85);
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transform-origin: center;
  trsnsform: scale(1) translateZ(0);
  transition: 
    filter 200ms linear,
    transform 200ms linear;
}

.card-spicker:hover .card__background{
  transform: scale(1.05) translateZ(0);
}

.card-grid:hover > .card:not(:hover) .card__background{
  filter: brightness(0.5) saturate(0) contrast(1.2) blur(30px);
}

.card__content{
  left: 10px;
  padding: var(--spacing-l);
  position: absolute;
  bottom: 0;
  color:white;
}

.card__category{
  color: var(--text-light);
  font-size: 0.9rem;
  margin-bottom: var(--spacing-s);
  text-transform: uppercase;
}

.card__heading{
  color: var(--text-lighter);
  font-size: 1.9rem;
  text-shadow: 2px 2px 20px rgba(0,0,0,0.2);
  line-height: 1.4;
  word-spacing: 100vw;
}
</style>
<style scoped>
/* Variables */
/* Fonts */
@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,700);


/* Styling */
.timeline {
  margin: 4em auto;
  position: relative;
  max-width: 46em;
}
.timeline:before {
  background-color: black;
  content: '';
  position: absolute;
  top: 0;
  left: 2em;
  width: 2px;
  height: 100%;
}

.timeline-event {
  position: relative;
}
.timeline-event:hover .timeline-event-icon {
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  background-color: #04A27C;
}
.timeline-event:hover .timeline-event-thumbnail {
  -moz-box-shadow: inset 40em 0 0 0 #04A27C;
  -webkit-box-shadow: inset 40em 0 0 0 #04A27C;
  box-shadow: inset 40em 0 0 0 #04A27C;
}

.timeline-event-copy {
  padding: 2em;
  position: relative;
  top: -1.875em;
  left: 4em;
  width: 80%;
}
.timeline-event-copy h3 {
  font-size: 1.75em;
}
.timeline-event-copy h4 {
  font-size: 1.2em;
  margin-bottom: 1.2em;
}
.timeline-event-copy strong {
  font-weight: 700;
}
.timeline-event-copy p:not(.timeline-event-thumbnail) {
  padding-bottom: 1.2em;
}

.timeline-event-icon {
  -moz-transition: -moz-transform 0.2s ease-in;
  -o-transition: -o-transform 0.2s ease-in;
  -webkit-transition: -webkit-transform 0.2s ease-in;
  transition: transform 0.2s ease-in;
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  background-color: black;
  outline: 10px solid white;
  display: block;
  margin: 0.5em 0.5em 0.5em -0.5em;
  position: absolute;
  top: 2em;
  left: -0.9em;
  width: 1em;
  height: 1em;
}

.timeline-event-thumbnail {
  -moz-transition: box-shadow 0.5s ease-in 0.1s;
  -o-transition: box-shadow 0.5s ease-in 0.1s;
  -webkit-transition: box-shadow 0.5s ease-in;
  -webkit-transition-delay: 0.1s;
  transition: box-shadow 0.5s ease-in 0.1s;
  color: white;
  font-size: 0.75em;
  background-color: black;
  -moz-box-shadow: inset 0 0 0 0em #16336E;
  -webkit-box-shadow: inset 0 0 0 0em #16336E;
  box-shadow: inset 0 0 0 0em #16336E;
  display: inline-block;
  margin-bottom: 1.2em;
  padding: 0.25em 1em 0.2em 1em;
}

</style>
<style scoped >
.cherdack {
  -webkit-box-shadow: 0 0 16px 0 rgb(0 0 0 / 20%);
  box-shadow: 0 9px 16px 0 rgb(0 0 0 / 20%);
  
}
.btn-shadow{
  -webkit-box-shadow: 0 0 16px rgb(51 51 51 / 20%);
    box-shadow: 0 0 16px rgb(51 51 51 / 20%);
}
.icon-mb{
  margin-bottom: 3px;
  margin-right: 3px;
}
.nav-link{
    color:#333 !important;
  cursor: pointer !important;
}
.btn-primary{
  color: #F0EFED !important;
  cursor: pointer !important;
}
.b {
  color: #333 !important;
}
.b-white {
  color: #F0EFED !important;
}
.dark-green-text{
  color: #16336E !important;
}
.bg-image-1{
  background: #04A27C url('https://pro-women.ru/local/templates/prowomen/assets/img/index/participantBg.png') bottom left no-repeat !important;
  color: white !important;
  font-weight: 500;
}
.bg-image-2{
  background: #16336E url('https://pro-women.ru/local/templates/prowomen/assets/img/index/liderBg.png') bottom left no-repeat !important;
  color: white !important;
  font-weight: 500;
}
.bg-image-3{
  background: #eff8f3  100% 100% no-repeat !important;
  background-size: cover; /* Масштабируем фон */
  color: white !important;
  font-weight: 500;
  border-radius: 10px;
}
.bg-image-4{
  background: linear-gradient(#effdf6 , #fff) url('https://pro-women.ru/local/templates/prowomen/assets/img/mentoring/mentoring-manual-item-bg.svg') top right no-repeat !important;
}
.bg-image-5{
  background: #04A27C url('https://pro-women.ru/local/templates/prowomen/assets/img/index/soviet-bg.svg') top right no-repeat !important;
  color: white !important;
  font-weight: 500;
}
.bg-image-6{
  background: #04A27C url('https://pro-women.ru/local/templates/prowomen/assets/img/index/subscribeBg.png') bottom right no-repeat !important;
  color: white !important;
  font-weight: 500;
}
.bg-image-0{
  background: linear-gradient(252.6deg, #04A27C -3.65%, #067D61 104.61%) !important;
}
/*  */

.gg-arrow-long-right {
  box-sizing: border-box;
  position: relative;
  display: block;
  transform: scale(var(--ggs, 1));
  border-top: 2px solid transparent;
  border-bottom: 2px solid transparent;
  box-shadow: inset 0 0 0 2px;
  width: 50%;
  top: 40%;
  left: 40%;
  right: 10%;
  height: 6px;
}
.gg-arrow-long-right::after {
  content: "";
  display: block;
  box-sizing: border-box;
  position: absolute;
  width: 6px;
  height: 6px;
  border-top: 2px solid;
  border-right: 2px solid;
  transform: rotate(45deg);
  right: 0;
  bottom: -2px;
}
@import "https://fonts.googleapis.com/css?family=Poppins:100,300,400,500,700,900";
@import "https://fonts.googleapis.com/css?family=Caveat";

@import "./landing_css/theme.css";

@import "./landing_css/all.css";
/* @import "./landing_css/aos.css"; */
@import "./landing_css/cookieconsent.min.css";
@import "./landing_css/magnific-popup.css";
@import "./landing_css/odometer-theme-minimal.css";
@import "./landing_css/prism-okaidia.css";
@import "./landing_css/simplebar.css";
@import "./landing_css/smart_wizard.css";
@import "./landing_css/smart_wizard_theme_arrows.css";
@import "./landing_css/smart_wizard_theme_circles.css";
@import "./landing_css/smart_wizard_theme_dots.css";
@import "./landing_css/swiper.css";
@import "./landing_css/theme.css";
@import "./landing_css/rtl.css";
@import "./landing_css/hover_menu.css";
@media (min-width: 1904px) {
  .container {
    max-width: 1185px !important;
  }
}
</style>


<script>
import AOS from "aos";
import CookieConsent from 'vue-cookieconsent-component'
import { mapState, mapActions,mapGetters } from 'vuex'


export default {
  data() {
    return {
      block_expand:{
        ur_profile:false,
        ec_profile:false,
        diff_profile:false
      },
      quest_org: [
        {
          text: "Текст ответа на вопрос",
          title: "Что такое аккредитация образовательной организции?",
        },
        { text: "Текст ответа на вопрос", title: "Как пройти аккредитацию?" },
        {
          text: "Текст ответа на вопрос",
          title: "Свидетельство об аккредитации",
        },
        { text: "Текст ответа на вопрос", title: "Какие нужны документы? " },
      ],
      quest_attested: [
        {
          text:
            "Повышение квалификации можно пройти в Палате налоговых консультантов или в одной из аккредитованных ПНК образовательных организаций. Формы повышения квалификации: Практикумы; Консультационные семинары; Налоговые видео-семинары; Зачет ситуаций; Психологические тренинги; Участие в проекте «Горячая линия»; Непрерывный курс в образовательной организации",
          title:
            "Заканчивается срок действия квалификационного аттестата, в какой форме можно пройти повышение квалификации?",
        },
        {
          text:
            "В течение 2 лет действия квалификационного аттестата налоговый консультант проходит повышение квалификации в объеме 72 ак. час.",
          title:
            "Сколько часов нужно для продления срока действия квалификационного аттестата?",
        },
        {
          text:
            "1.	Заявление поданное через личный кабинет <br>2.	Согласие на обработку персональных данных. <br>3.	Сканы удостоверения(й) подтверждающие 72ч. повышения квалификации. <br>4.	Подтверждение оплаты членских взносов за последние 3 года, включая текущий год",
          title:
            "Какие документы, необходимые для оформления свидетельства о продлении срока действия квалификационного аттестата ",
        },
        {
          text:
            "Да, можно. Если срок действия Вашего квалификационного аттестата истек более года назад, Вам необходимо: <br>1.	подать ходатайство о восстановлении квалификационного аттестата; <br>2.	к ходатайству приложить подтверждение оплаты задолженности по членским взносам за 3 календарных года, включая текущий; <br>3.	пройти повышение квалификации в объеме 72 ак. часов ",
          title:
            "Можно ли восстановить срок действия квалификационного аттестата?",
        },
        {
          text:
            "Закончился срок действия квалификационного аттестата или не оплачен членский взнос",
          title:
            "Не вижу себя в реестре аттестованных налоговых консультантов?",
        },
      ],
      quest_cons: [
        {
          text:
            "В зависимости от выбранной программы, необходимым условием допуска является наличие среднего профессионального (экономического/юридического) или высшего",
          title: "Требуется ли высшее образование для обучения?",
        },
        {
          text:
            "180, 260  или 260 аккадемических часов требуется для того, чтобы освоить программу",
          title: "Какое количество академических часов длится обучение?",
        },
        //   {text: 'Налоговый консультант - специалист оказывающий квалифицированное содействие налогоплательщикам (физическим и юридическим лицам) при исполнении налоговых обязанностей.  Для этого налоговый консультант должен обладать знаниями экономики, юриспруденции и собственно налогообложения. Требования к квалификации содержаться в Квалификационном справочнике. В настоящее время Союзом «ПНК» разработан и в декабре 2020 года внесён в Минтруд РФ проект профстандарта «Консультант по налогам и сборам». Деятельность налогового консультанта (консультанта по налогам и сборам) существенно отличается от деятельности представителей других профессий. Это легко увидеть ознакомившись с трудовыми функциями и действиями.' ,title: 'Кто такой налоговый консультант? Чем он отличается от юриста, бухгалтера, аудитора и т.п.?'},
        {
          text:
            "Обучение по программе Палаты налоговых консультантов проводят аккредитованные  образовательные организации.Обучение завершается обязательной сдачей итогового контроля знаний (экзамена). ",
          title: "Как проходит обучение?",
        },
      ],
    };
  },
  mounted (){
      this.get_lectors()
  },
  methods: {
      ...mapActions('app', ['GET_LECTORS']),
    page(page) {
      location.href = page;
    },
    lector_background(url){
        return `background-image: url(${url})`
    },
    get_lectors(){
        this.GET_LECTORS()
    },
    expand(block){
      this.block_expand[block] = !this.block_expand[block] 
    }
  },
  created() {
    AOS.init();
  },
  components: {CookieConsent},
  computed: {
    ...mapState('app', ['lectors']),

  },
};
</script>